var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("hr"),
    _vm._v(" "),
    _c("h5", [
      _c("strong", [
        _vm._v(
          _vm._s(_vm.$t("MAIN_CONTENT.BuildingInformation.buildingInformation"))
        )
      ])
    ]),
    _vm._v(" "),
    _c("br"),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      !!_vm.buildingInformation.PHONE_NUMBER
        ? _c("div", { staticClass: "col-sm-4" }, [
            _c("strong", [
              _vm._v(
                "\n\t\t\t\t" +
                  _vm._s(
                    _vm.$t("MAIN_CONTENT.BuildingInformation.phoneWithColon")
                  ) +
                  "\n\t\t\t"
              )
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(
              "\n\t\t\t" +
                _vm._s(_vm.buildingInformation.PHONE_NUMBER) +
                "\n\t\t"
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      !!_vm.buildingInformation.FAX_NUMBER
        ? _c("div", { staticClass: "col-sm-4" }, [
            _c("strong", [
              _vm._v(
                "\n\t\t\t\t" +
                  _vm._s(
                    _vm.$t("MAIN_CONTENT.BuildingInformation.faxWithColon")
                  ) +
                  "\n\t\t\t"
              )
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(
              "\n\t\t\t" + _vm._s(_vm.buildingInformation.FAX_NUMBER) + "\n\t\t"
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      !!_vm.buildingInformation.ADDRESS_1 ||
      !!_vm.buildingInformation.CITY ||
      !!_vm.buildingInformation.STATE_CODE ||
      !!_vm.buildingInformation.ZIP_CODE
        ? _c(
            "div",
            { staticClass: "col-sm-4" },
            [
              _c("strong", [
                _vm._v(
                  "\n\t\t\t\t" +
                    _vm._s(
                      _vm.$t(
                        "MAIN_CONTENT.BuildingInformation.addressWithColon"
                      )
                    ) +
                    "\n\t\t\t"
                )
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(
                "\n\t\t\t" +
                  _vm._s(_vm.buildingInformation.ADDRESS_1) +
                  "\n\t\t\t"
              ),
              _c("br"),
              _vm._v("\n\t\t\t" + _vm._s(_vm.buildingInformation.CITY)),
              !!_vm.buildingInformation.CITY &&
              !!_vm.buildingInformation.STATE_CODE
                ? [_vm._v(", ")]
                : _vm._e(),
              _vm._v(
                "\n\t\t\t" +
                  _vm._s(_vm.buildingInformation.STATE_CODE) +
                  " " +
                  _vm._s(_vm.buildingInformation.ZIP_CODE) +
                  "\n\t\t\t"
              ),
              !!_vm.buildingInformation.ZIP_CODE_EXT
                ? [_vm._v("-" + _vm._s(_vm.buildingInformation.ZIP_CODE_EXT))]
                : _vm._e()
            ],
            2
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("br"),
    _vm._v(" "),
    _vm.adminInfo.length > 0
      ? _c(
          "div",
          { staticClass: "row" },
          _vm._l(_vm.adminInfo, function(administrator, idx) {
            return _c(
              "div",
              {
                key:
                  "adinistrator_" +
                  _vm.buildingInformation.SCHOOL_ID +
                  "_" +
                  idx,
                staticClass: "col-sm-4"
              },
              [
                !!administrator.ADMINISTRATOR_DESC
                  ? _c("strong", [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(
                            _vm.$t(
                              "MAIN_CONTENT.BuildingInformation.staffTitle",
                              { title: administrator.ADMINISTRATOR_DESC }
                            )
                          ) +
                          "\n\t\t\t"
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("br"),
                _vm._v("\n\t\t\t" + _vm._s(administrator.STAFF_NAME) + "\n\t\t")
              ]
            )
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }